import moment from 'moment';

let validBrowser = window.Promise !== undefined && window.Promise !== null && Object.prototype.toString.call(window.Promise.resolve()) === '[object Promise]' ? true : false
if(!validBrowser) {
    document.querySelector('.site-footer').style.display = 'none' // WTF!?
}

const mainDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.main_domain
const siteDomain = pmkinoFrontVars && pmkinoFrontVars.cinemaData.site.url_site
if(siteDomain && mainDomain) {
    document.cookie = "last_visited=" + siteDomain + "; domain=" + mainDomain 
}



moment.locale(pmkinoFrontVars && pmkinoFrontVars.translation && pmkinoFrontVars.translation.locale ? pmkinoFrontVars.translation.locale : 'de-DE');